import { client } from "@/api/client";
import interceptors from "@/api/interceptors";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function optionBank(params) {
	return client.get("api/ecommerce/common/option-bank", {
		params: params,
	});
}

function optionProduct(params) {
	return client.get("api/ecommerce/common/option-product", {
		params: params,
	});
}

export default {
	optionBank,
	optionProduct,
}